var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentRequestInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72469 16.0833C12.6367 16.0833 15.808 12.912 15.808 8.99999C15.808 5.08797 12.6367 1.91666 8.72469 1.91666C4.81267 1.91666 1.64136 5.08797 1.64136 8.99999C1.64136 12.912 4.81267 16.0833 8.72469 16.0833Z",
    fill: "#0B1421",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72461 6.875C9.31141 6.875 9.78711 6.3993 9.78711 5.8125C9.78711 5.2257 9.31141 4.75 8.72461 4.75C8.13781 4.75 7.66211 5.2257 7.66211 5.8125C7.66211 6.3993 8.13781 6.875 8.72461 6.875Z",
    fill: "#0B1421"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72461 8.29167C8.13781 8.29167 7.66211 8.76736 7.66211 9.35417V12.1875C7.66211 12.7743 8.13781 13.25 8.72461 13.25C9.31141 13.25 9.78711 12.7743 9.78711 12.1875V9.35417C9.78711 8.76736 9.31141 8.29167 8.72461 8.29167Z",
    fill: "#0B1421"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRequestInfo);
export default __webpack_public_path__ + "static/media/document-request-info.e01189d3c368af64c20f1d44e1843d10.svg";
export { ForwardRef as ReactComponent };